import {
  ApiEndpoints,
  StudyCapabilities,
  StudyPermissionsResponse,
  OrganizationCapabilities,
  OrganizationPermissionsResponse,
  SystemCapabilities,
  SystemPermissionsResponse,
  SiteCapabilities,
  SitePermissionsResponse,
  DeviceCapabilities,
  DevicePermissionsResponse,
} from 'adc-sirius-module-common';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import { urls } from '../utilities/dataHelpers';

const handleGetCapabilities = (
  request: MediatorRequestWithResponse<SystemCapabilities>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SystemPermissionsResponse>('api:invoke', {
        method: ApiEndpoints.EP_PERMISSIONS_GET_CAPABILITIES.Method,
        url: urls.api + ApiEndpoints.EP_PERMISSIONS_GET_CAPABILITIES.Path,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.capabilities);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const handleGetOrganizationCapabilities = (
  request: MediatorRequestWithResponse<OrganizationCapabilities>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OrganizationPermissionsResponse>('api:invoke', {
        method: ApiEndpoints.EP_PERMISSIONS_ORGANIZATION.Method,
        url: `${urls.api}${ApiEndpoints.EP_PERMISSIONS_ORGANIZATION.Path.replace(':key', request.key)}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.capabilities);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const handleGetStudyCapabilities = (
  request: MediatorRequestWithResponse<StudyCapabilities>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<StudyPermissionsResponse>('api:invoke', {
        method: ApiEndpoints.EP_PERMISSIONS_STUDY.Method,
        url: `${urls.api}${ApiEndpoints.EP_PERMISSIONS_STUDY.Path.replace(
          ':key',
          request.key,
        )}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.capabilities);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const handleGetSiteCapabilities = (
  request: MediatorRequestWithResponse<SiteCapabilities>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SitePermissionsResponse>('api:invoke', {
        method: ApiEndpoints.EP_PERMISSIONS_SITE.Method,
        url: `${urls.api}${ApiEndpoints.EP_PERMISSIONS_SITE.Path.replace(
          ':key',
          request.key,
        )}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.capabilities);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

mediator.subscribe('capability:getSystemCapabilities', handleGetCapabilities);
mediator.subscribe(
  'capability:getOrganizationCapabilities',
  handleGetOrganizationCapabilities,
);
mediator.subscribe(
  'capability:getStudyCapabilities',
  handleGetStudyCapabilities,
);
mediator.subscribe('capability:getSiteCapabilities', handleGetSiteCapabilities);

const handleGetDeviceCapabilities = (
  request: MediatorRequestWithResponse<DeviceCapabilities>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<DevicePermissionsResponse>('api:invoke', {
        method: ApiEndpoints.EP_PERMISSIONS_DEVICE.Method,
        url: `${urls.api}${ApiEndpoints.EP_PERMISSIONS_DEVICE.Path.replace(
          ':key',
          request.key,
        )}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.capabilities);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

mediator.subscribe(
  'capability:getDeviceCapabilities',
  handleGetDeviceCapabilities,
);
